<template>
  <div class="GreetingComponent">
    <dh-hero/>
    <dh-introduction>
      <p>
        Looking for a way to reach out to your customers online? No matter which stage of your business you're at,
        we're here
        to help!
      </p>
      <p>
        DHO Consulting has been giving businesses a jump start over the competition by providing quality, stress free
        IT, design and marketing solutions since 2000.
      </p>
    </dh-introduction>

    <section class="py-12 three-points">
      <h2 class="mb-10">Our Solutions</h2>
      <three-points>
        <template #one>
          <dh-card>
            <template #title>
              <dh-card-title>
                Design
              </dh-card-title>
            </template>
            <template #text>
              <p>Logo</p>
              <p>Landing Pages</p>
              <p>User Experience (UX)</p>
              <p>Web Design</p>
              <p>App Design</p>
            </template>
          </dh-card>
        </template>
        <template #two>
          <dh-card>
            <template #title>
              <dh-card-title>
                IT
              </dh-card-title>
            </template>
            <template #text>
              <p>Email Setup</p>
              <p>Web Hosting</p>
              <p>Web Development</p>
              <p>Custom Web Software</p>
              <p>Mobile Software</p>
              <p>Payment Processor</p>
              <p>Ecommerce</p>
            </template>
          </dh-card>
        </template>
        <template #three>
          <dh-card>
            <template #title>
              <dh-card-title>
                Marketing
              </dh-card-title>
            </template>
            <template #text>
              <p>Sales Copy</p>
              <p>Google Adwords</p>
              <p>Facebook Ads</p>
              <p>SEO</p>
            </template>
          </dh-card>
        </template>
      </three-points>
    </section>

    <dh-cta>
      <div class="text-center">
        <p>Don't be a stranger! Give us a shout and let's talk about how we can work together to improve your
          business.</p>
        <v-btn
          href="mailto:dan@dhoconsulting.com" large class="green white--text">
          Contact Us Now
        </v-btn>
      </div>
    </dh-cta>
  </div>
</template>

<script>
  import DhHero from './widget/DhHero'
  import DhIntroduction from './widget/DhIntroduction'
  import ThreePoints from './structure/ThreePoints'
  import DhCard from './widget/DhCard'
  import DhCardTitle from './widget/DhCardTitle'
  import DhCta from './widget/DhCta'

  export default {
    name: 'Greeting',
    components: { DhCta, DhCardTitle, DhCard, ThreePoints, DhIntroduction, DhHero },
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {},
    watch: {},
    mixins: [],
    data: function () {
      return {}
    },
    methods: {},
    created () {
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .GreetingComponent {
    p {
      font-family: var(--font-body);
      font-size: var(--font-size-normal-body);

    }

    .three-points {
      h2 {
        font-family: var(--font-title);
        text-align: center;
      }

      p {
        text-align: center;
      }
    }
  }
</style>
